import { useMemo, useCallback } from 'react';

const useKeyboardControls = ({
  convertStringToDates,
  handleApply,
  handleClose,
  open,
  setFirstFocusedElement,
  setOpen,
}) => {
  const handleInputKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        const [start, end] = convertStringToDates(e.target.value);
        handleApply(start, end);
      }
    },
    [convertStringToDates, handleApply]
  );
  const handleWrapperKeyDown = useCallback(
    (e) => {
      switch (e.key) {
        case 'Tab':
        case 'Escape':
          handleClose();
          break;
        case 'ArrowDown':
          setFirstFocusedElement(true);
          if (!open) setOpen(true);
          break;
        default:
          break;
      }
    },
    [handleClose, setFirstFocusedElement, open, setOpen]
  );

  return useMemo(
    () => ({ handleInputKeyDown, handleWrapperKeyDown }),
    [handleWrapperKeyDown, handleInputKeyDown]
  );
};

export default useKeyboardControls;
